import { Card, CardContent, Typography, Box, Chip, Divider, Paper } from "@mui/material";
import { Phone, Message, WhatsApp, VerifiedUser, ShoppingCart, LocalShipping } from '@mui/icons-material';
import * as React from 'react'
import PageTitle from "../../../components/PageTitle";
import ProzoDataGrid from "../../../common/ProzoDataGrid";
import { apiConstants, getGeneric } from "../../../common/constants";
import { useEffect } from "react";

function NotificationPricing({ id, merchant }) {
    const [pricingData, setPricingData] = React.useState([]);

    const fetchMerchantDetails = () => {
        getGeneric(`${apiConstants.MERCHANT_DETAILS}/${id}`).then((response) => {
            setPricingData(response.data?.communicationPricing)
        }).catch((err) => {
            console?.error(err)
        })
    };

    useEffect(() => {
        fetchMerchantDetails()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const columns2 = [
        {
            field: 'perAWBCall',
            headerName: 'Per AWB Call',
            flex: 0.8,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Phone sx={{ fontSize: 18, color: 'primary.main' }} />
                    <Typography variant="body2" fontWeight="500">
                        ₹{params.value || '0.00'}
                    </Typography>
                </Box>
            )
        },
        {
            field: 'perAWBNdr',
            headerName: 'Per NDR Call',
            flex: 0.8,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <LocalShipping sx={{ fontSize: 18, color: 'warning.main' }} />
                    <Typography variant="body2" fontWeight="500">
                        ₹{params.value || '0.00'}
                    </Typography>
                </Box>
            )
        },
        {
            field: 'perChannelAddressVerificationWA',
            headerName: 'Address Verification WA',
            flex: 1.2,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <VerifiedUser sx={{ fontSize: 18, color: 'success.main' }} />
                    <Typography variant="body2" fontWeight="500">
                        ₹{params.value || '0.00'}
                    </Typography>
                </Box>
            )
        },
        {
            field: 'perChannelOrderConfirmationWA',
            headerName: 'Order Confirmation WA',
            flex: 1.2,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <ShoppingCart sx={{ fontSize: 18, color: 'info.main' }} />
                    <Typography variant="body2" fontWeight="500">
                        ₹{params.value || '0.00'}
                    </Typography>
                </Box>
            )
        },
        {
            field: 'perConnectedCall',
            headerName: 'Connected Call',
            flex: 0.8,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Phone sx={{ fontSize: 18, color: 'secondary.main' }} />
                    <Typography variant="body2" fontWeight="500">
                        ₹{params.value || '0.00'}
                    </Typography>
                </Box>
            )
        },
        {
            field: 'perSMS',
            headerName: 'Per SMS',
            headerAlign: 'center',
            flex: 0.6,
            align: 'center',
            renderCell: (params) => (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Message sx={{ fontSize: 18, color: 'error.main' }} />
                    <Typography variant="body2" fontWeight="500">
                        ₹{params.value || '0.00'}
                    </Typography>
                </Box>
            )
        },
        {
            field: 'perWA',
            headerName: 'Per WA',
            headerAlign: 'center',
            flex: 0.6,
            align: 'center',
            renderCell: (params) => (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <WhatsApp sx={{ fontSize: 18, color: '#25D366' }} />
                    <Typography variant="body2" fontWeight="500">
                        ₹{params.value || '0.00'}
                    </Typography>
                </Box>
            )
        },
    ]

    return (
        <Box sx={{ p: 3, backgroundColor: '#f8fafc', minHeight: '100vh' }}>
            <Box sx={{ mb: 4 }}>
                <PageTitle>Communication Pricing</PageTitle>
                {merchant && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                        <Chip
                            label={merchant}
                            color="primary"
                            variant="outlined"
                            sx={{ fontWeight: 500 }}
                        />
                    </Box>
                )}
            </Box>

            <Box sx={{ display: 'grid', gap: 3, gridTemplateColumns: { xs: '12', md: '12' } }}>
                {/* Main Pricing Table */}
                <Card sx={{
                    borderRadius: 3,
                    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
                    border: '1px solid rgba(0,0,0,0.06)'
                }}>
                    <CardContent sx={{ p: 3 }}>
                        <Box sx={{ mb: 3 }}>
                            <Typography variant="h6" fontWeight="600" color="text.primary" gutterBottom>
                                Communication Service Pricing
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                Detailed pricing breakdown for all communication services
                            </Typography>
                        </Box>

                        <ProzoDataGrid
                            columns={columns2}
                            getRowId={(row) => Math.random()}
                            rows={pricingData ? [pricingData] : []}
                            autoHeight={true}
                            hideFooterPagination={true}
                            getRowHeight={() => 60}
                            sx={{
                                '& .MuiDataGrid-cell': {
                                    borderBottom: '1px solid rgba(0,0,0,0.06)',
                                },
                                '& .MuiDataGrid-columnHeaders': {
                                    backgroundColor: '#f8fafc',
                                    borderBottom: '2px solid rgba(0,0,0,0.1)',
                                },
                                '& .MuiDataGrid-columnHeader': {
                                    fontWeight: 600,
                                }
                            }}
                        />
                    </CardContent>
                </Card>
            </Box>
        </Box>
    );
}

export default NotificationPricing;
